import React from "react";
import { Checkbox as AntdCheckbox } from "antd";

interface props {
  checked: boolean;
  label: string;
  onChange: (name: string, value: boolean) => void;
  name: string;
  disabled?: boolean;
}

const CheckBox: React.FC<props> = ({ checked, label, onChange, name, disabled }) => {
  const changeHandler = (event: { target: { checked: boolean } }) => {
    onChange(name, event.target.checked);
  };

  return (
    <AntdCheckbox
      checked={checked}
      onChange={changeHandler}
      disabled={disabled}
      className={`!flex !flex-row !justify-start !items-center !gap-px ${
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      }`}
    >
      <span className="pt-1 whitespace-nowrap text-xs">{label}</span>
    </AntdCheckbox>
  );
};

export default CheckBox;
